var _g;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNbLogo(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 499.7 142.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "182,18.2 200.2,18.2 200.2,65.6 218.3,65.6 218.3,0 163.8,0 163.8,65.6 182,65.6  "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.5,65.6h4.2l0-65.6h-41.8v18.2h23.6v5.5h-36.2v42h42.2H279.5z M265.5,47.4h-18.1v-5.5h18.1V47.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.4,142.1h4.2l0-65.6h-41.8v18.2h23.6v5.5h-36.2v42h42.2H308.4z M294.5,123.8h-18.1v-5.5h18.1V123.8z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "312.8,18.2 330.9,18.2 330.9,65.6 349.1,65.6 349.1,0 294.6,0 294.6,65.6 312.8,65.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "341.9,94.7 360,94.7 360,142.1 378.2,142.1 378.2,76.5 323.7,76.5 323.7,142.1 341.9,142.1  "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.3,65.6h4.2l0-65.6h-41.8v18.2h23.6v5.5h-36.2v42h42.2H410.3z M396.3,47.4h-18.1v-5.5h18.1V47.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.5,142.1h4.2l0-65.6h-41.8v18.2h23.6v5.5h-36.2v42h42.2H495.5z M481.6,123.8h-18.1v-5.5h18.1V123.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.3,142.1V94.7H182V76.5h-18.2v65.6H218.3z M200.2,123.8H182v-10.9h18.2V123.8z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "389,142.1 434.5,142.1 434.5,123.8 407.2,123.8 407.2,94.7 434.5,94.7 434.5,76.5 389,76.5  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 229.3,
    y: 76.5,
    width: 18.1,
    height: 65.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.1,97.3c-1.9-1.9-2.8-4.5-2.8-7.2V70.8V51.6c0.1-2.7,1-5.3,2.8-7.3l36.3-36c1.9-1.9,1.9-5,0-6.8h0l0,0 c-1.9-1.9-5-1.9-6.8,0l-36.3,36c-1.9,1.9-4.6,3.3-7.2,3.3H70.8H51.8c-2.7,0-5.6-1.5-7.6-3.3l-36-36c-1.9-1.9-4.9-1.9-6.8,0l0,0 l0,0c-1.9,1.9-1.9,5,0,6.8l36,36c1.9,1.9,2.9,4.5,2.9,7.2l0,19.3l0,19.3c0,2.7-1.1,5.2-2.9,7.2l-36,36.6c-1.9,1.9-1.9,4.9,0,6.8 l0,0l0,0c1.9,1.9,5,1.9,6.8,0l36-36.6c1.9-1.8,4.5-2.5,7.2-2.5h19.2h19.4c2.7,0,5.5,1.1,7.4,2.9l35.9,36.2c1.9,1.9,4.9,1.9,6.8,0 l0,0h0c1.9-1.9,1.9-5,0-6.8L104.1,97.3z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNbLogo);
export default __webpack_public_path__ + "static/media/nb-logo.a6b3e7f6f13739265399f8613d0da286.svg";
export { ForwardRef as ReactComponent };